import React, { useState } from 'react';
import {FaLocationDot} from "react-icons/fa6";
import {filterOptions} from "../data";
import {FaChevronCircleDown} from "react-icons/fa";
import "./Hero.css";
import { useNavigate } from 'react-router-dom';


const Hero = ({style}) => {

  const [activeButton, setActivButton] =useState("buy")
  const [openFilter, setopenFilter] = useState(null)
  const [selectedOptions, setSelectedOptions] = useState(
    filterOptions.map((filter) => filter.options[0])
  )

  const handleButtonClick = (buttonType)  =>{
    setActivButton(buttonType)
  };

  const handleFilterClick = (index) =>{
    setopenFilter(openFilter === index ? null : index)
  };

  const handleOptionSelect = (filterIndex,option) => {
    const updateOptions =  [...selectedOptions]
    updateOptions[filterIndex] = option
    setSelectedOptions(updateOptions)
    setopenFilter(null)
  };

  const navigate =useNavigate()
  const handleNavigate = () =>{
    navigate("/property");
  }


  return (
 
    <div className='hero' style={style}>
    <div className='hero-container'>
      <h1>دعنا نجد منزلك المثالي مع عقاري</h1>
      <p>جعل البحث عن منزلك سهلاً وممتعًا</p>
      <h1>شركة عقارات عصرية
حيث نضع عملائنا في صميم كل ما نقوم به</h1>
      <h3>شركة عقارات في السعودية</h3>

      <div className='buttons-container'>
        <button className={activeButton === "buy" ? "active" : ""} onClick={()=> handleButtonClick("buy")}>شراء خصائص</button>
        <button  className={activeButton === "rent" ? "active" : ""} onClick={()=> handleButtonClick("rent")}>عقارات للإيجار</button>
      </div>



          </div>
        </div>
     
    
  
  )
}

export default Hero;
